<template>
    <div class="header" :style="{backgroundImage: 'url('+data.pageTitle.banner+')'}">
        <div :class="data.pageTitleClass">
            <div class="title-cn">{{ data.pageTitle.cn }}</div>
            <div class="title-en">{{ data.pageTitle.en }}</div>
        </div>
        <div class="searchInput" v-if="data.hasSearch">
            <a-input-search
                v-model:value="data.value"
                placeholder="输入搜索内容"
                @search="onSearch"
            />
        </div>
    </div>
</template>

<script>
import { onMounted, reactive } from 'vue'
// import { notification } from 'ant-design-vue'
export default {
    name: "Header",
    props: {
        pageTitle: Object
    },
    setup(props, { emit }) {
        const data = reactive({
            value: '',
            pageTitleClass: 'pageTitle',
            pageTitle: {
                cn: '',
                en: '',
                banner: ''
            },
            hasSearch: false
        })
        const onSearch = (searchValue) => {
            emit('search', searchValue)
        }
        onMounted(() => {
            if (props.pageTitle.hasSearch) {
                // 是否启用搜索
                data.hasSearch = true
            }
            if (!props.pageTitle.titleStyle) {
                // Title样式
                data.pageTitleClass = 'pageTitle-normal'
            }
            data.pageTitle = props.pageTitle
            // notification.success({ message: 'SUCCESS!', description: 'SUCCESS', duration: 5 })
        })
        return {
            data,
            onSearch
        }
    }
}
</script>
<style scoped lang="stylus">
    .header {
        width 100%
        height 170px
        position relative
        background-color #309CEC
        //background-image url("../../assets/img/page_banner_0.png")
        background-size 100% 100%
        .pageTitle {
            width 100%
            height 50px
            font-weight: bold
            -webkit-text-fill-color: #FFF/*文字的填充色*/
            -webkit-text-stroke: 0.6px #0B9A01
            position absolute
            text-align center
            left 0
            top calc(50% - 25px)
            //color #FFF
            text-shadow: 0 3px 6px rgba(0, 0, 0, 0.35)
            .title-cn {
                font-size 20px
            }
            .title-en {
                font-size 12px
            }
        }
        .pageTitle-normal {
            width 100%
            height 50px
            font-weight: bold
            position absolute
            left 0
            top calc(50% - 25px)
            text-align center
            color #575757
            .title-cn {
                font-size 20px
            }
            .title-en {
                font-size 12px
            }
        }
        .searchInput {
            width 100%
            position absolute
            top 70%
            text-align center
        }
        .searchInput >>> .ant-input-search {
            width 200px
        }
    }
</style>